import React, { useRef } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";
import { Lead_Creation } from "../../../Configuration/API_URL";
import { useEffect } from "react";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function IndividualAccountDetails() {
  const storeToken = localStorage.getItem("ssoToken");
  const [individualData, setIndividualData] = useState("")


    const IndividualDetails = async () => {
        
        try {
          const getOtp = await axiosInstance.get(
            Lead_Creation.Overview_Individual,
          );
          const res = ApiResDecrypt(getOtp?.data);
          console.log(res, "res0000");
    
          if (res?.status === 0) {
            setIndividualData(res?.data)
          } else {
            toast.error(res?.message);
          }
        } catch (error) {
          console.log(error);
        } finally {
        }
      };

      useEffect(()=>{
        IndividualDetails()
      }, []);

  return (
    <div className="overview-card-sec">
      {/* <form onSubmit={handleSubmit(onFinalSubmit)}> */}
      <div className="card-box">
        <div className="over-inside-wrapper">
          <label className="input-title">Individual’s Accounts</label>
          <div className="card-indi">
            <ul>
              <li className="opened-section">
                <span className="sec-title">Accounts Opened</span>
                <span className="sec-value">{individualData?.openedAccount}</span>
              </li>
              <li className="pending-section">
                <span className="sec-title">Pending Accounts</span>
                <span className="sec-value">{individualData?.pendingAccount}</span>
              </li>
              <li className="total-section">
                <span className="sec-title">Total Accounts</span>
                <span className="sec-value">{individualData?.totalAccount}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* </form> */}
    </div>
  );
}

export default IndividualAccountDetails;
